import React from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import BecomeAgentBanner from "../component/BecomeAgentBanner";
import CreateAccountCTA from "../component/CreateAccountCTA";
import { Col, Container, Row } from "react-bootstrap";
import BecomeAgentImage1 from "../assets/images/become-agent-img-1.png";
import BecomeAgentImage2 from "../assets/images/become-agent-img-1.png";
import BecomeAgentImage3 from "../assets/images/become-agent-img-1.png";
import BecomeAgentIcon1 from "../assets/images/become-agent-icon-1.svg";
import BecomeAgentIcon2 from "../assets/images/become-agent-icon-2.svg";
import BecomeAgentIcon3 from "../assets/images/become-agent-icon-3.svg";
function BecomeAgent() {
  return (
    <>
      <div className="main become-agent-page">
        <Header />
        <BecomeAgentBanner />
        <div className="become-agent-content common-padding">
          <Container>
            <Row className="row-gap-100 align-items-center">
              <Col md={12} lg={6}>
                <div className="become-agent-img">
                  <img src={BecomeAgentImage1} alt="Become an Agent" />
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="become-agent-text pl-25">
                  <div className="become-agent-icon">
                    <img src={BecomeAgentIcon1} alt="" />
                  </div>
                  <h2>
                    Stand out with a <span>strong profile</span>
                  </h2>
                  <p>
                    Create a compelling profile that highlights your expertise, experience, and unique selling points to attract potential clients and stand out in a competitive market.
                  </p>
                </div>
              </Col>
              <Col md={12} lg={6} className="order-2 order-lg-0">
                <div className="become-agent-text pr-25">
                  <div className="become-agent-icon">
                    <img src={BecomeAgentIcon2} alt="" />
                  </div>
                  <h2>
                    Showcase your <span>listings</span>
                  </h2>
                  <p>
                    Display your property listings with high-quality photos, detailed descriptions, and virtual tours to showcase the best features and attract serious buyers.
                  </p>
                </div>
              </Col>
              <Col md={12} lg={6} className="order-1 order-lg-0">
                <div className="become-agent-img">
                  <img src={BecomeAgentImage2} alt="Become an Agent" />
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="become-agent-img">
                  <img src={BecomeAgentImage3} alt="Become an Agent" />
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="become-agent-text pl-25">
                  <div className="become-agent-icon">
                    <img src={BecomeAgentIcon3} alt="" />
                  </div>
                  <h2>
                    Leverage <span>your team</span>
                  </h2>
                  <p>
                    Collaborate with your team members on the platform to share leads, coordinate showings, and provide seamless service to your clients.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <CreateAccountCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default BecomeAgent;
